import { inject, Injectable } from '@angular/core';
import { BusinessProfile, UserAccount } from '@iot-platform/models/common';
import { User } from '@iot-platform/models/oyan';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { UsersService } from '../../services/users.service';
import { AdminUsersPageActions } from '../actions';

@Injectable({
  providedIn: 'root'
})
export class AdminUsersFacade {
  private readonly store: Store = inject(Store);
  private readonly usersService: UsersService = inject(UsersService);

  getBusinessProfilesByUserId(userId: string): void {
    this.store.dispatch(AdminUsersPageActions.getBusinessProfilesByUserId({ userId }));
  }

  getBusinessProfilesById(id: string): Observable<BusinessProfile[]> {
    return this.usersService.getBusinessProfilesByUserId(id);
  }

  getUserAccountById(id: string): Observable<UserAccount> {
    return this.usersService.getById(id);
  }

  addUser(user: User): void {
    this.store.dispatch(AdminUsersPageActions.addUser({ newUser: user }));
  }

  updateUser(user: User): void {
    this.store.dispatch(AdminUsersPageActions.updateUser({ updatedUser: user }));
  }
}
